import axios from '@/libs/axios'

export class HistoryMapService {


  static async getHistory(params) {
    return new Promise((resolve, reject) => {
      axios.get(`maps/getHistory`, { params: params})
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  static async getDevicesOptions(params) {
    return new Promise((resolve, reject) => {
      axios.get(`userGetLinked`, { params: params})
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }

  static async getGeofences(params) {
    return new Promise((resolve, reject) => {
      axios.get('maps/get_geofence', { params})
        .then(res => resolve(res))
        .catch(e => reject(e))
    })
  }


}
